class ProductService {

  static $inject = [
    '$ngRedux',
  ];

  constructor(
    $ngRedux,
  ) {
    this.$ngRedux = $ngRedux;
  }

  // Determine if a product is available to the current user, possibly in the context of a particular group.
  //
  // Parameters:
  //   productCode: Snake-cased upper-cased code of the product ('PATIENT_SCHEDULING')
  //                NOTE: The 'PRODUCT_GROUP_' prefix should not be included
  //   group (optional): Object that required either an id or a code that identifies the group
  //
  // Return:
  //   (boolean): True if product is available
  //
  // Usage:
  //   ProductService.isAvailable('MEETING_NOTIFICATIONS')
  //   ProductService.isAvailable('PATIENT_SCHEDULING', group)
  //   ProductService.isAvailable('PATIENT_SCHEDULING', {id: 123})
  //   ProductService.isAvailable('PATIENT_SCHEDULING', {code: 'CLIN-ABC'})
  //
  isAvailable(productCode) {
    // Sample structure of product codes in the session
    //
    //  {
    //    commonProducts: ['C', 'D'],
    //    groups: [
    //      {
    //        code: 'P',
    //        products: ['E', 'F']
    //      },
    //      {
    //        code: 'Q',
    //        products: ['G', 'H']
    //      },
    //    ]
    //  }
    //

    const session = this.$ngRedux.getState().session;

    if (!session || !session.commonProducts || !session.groups || (!session.authenticatedPatientId && !session.account)) {
      // Not logged in so check if product is in public group
      let products = null;
      const group = this.$ngRedux.getState().group;
      if (group) {
        products = [...(group.products ? group.products : []), ...(group.commonProducts ? group.commonProducts : [])];
      }
      if (products) {
        return _.includes(products, productCode);
      }
      return false;
    }

    // Check if the product is generally available (common)
    if (_.includes(_.union(session.commonProducts), productCode)) {
      return true;
    }

    const selectedGroup = this.$ngRedux.getState().group;

    // The account is member of the group, check for the restricted product availability
    if (selectedGroup) {
      return _.includes(selectedGroup.products, productCode);
    }

    return false;
  }
}

module.exports = ProductService;



// WEBPACK FOOTER //
// ./main/services/product-service.js